import { Link } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import "../styles/Navigation.css";

const Navigation = () => {
  return (
    <div className="navigation-wrapper">
      {/* Navigation Bar */}
      <Navbar bg="dark" variant="dark" expand="md" className="custom-navbar" collapseOnSelect>
        <Container>
          {/* Brand/Logo */}
          <Navbar.Brand as={Link} to="/" className="brand-logo d-flex align-items-center">
            <img
              src="/images/logo1.png"
              width="40"
              height="40"
              className="logo-img me-2"
              alt="Company Logo"
            />
            <span className="company-name d-none d-sm-inline">SAL PITA</span>
          </Navbar.Brand>

          {/* Toggle Button */}
          <Navbar.Toggle 
            aria-controls="responsive-navbar-nav" 
            className="custom-toggler"
            aria-label="Toggle navigation"
          >
            <div className="animated-hamburger">
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </div>
          </Navbar.Toggle>

          {/* Navigation Items */}
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto nav-links">
              <Nav.Link as={Link} to="/" className="nav-link-item" eventKey="1">Home</Nav.Link>
              <Nav.Link as={Link} to="/contact" className="nav-link-item" eventKey="2">Contact Us</Nav.Link>
              <Nav.Link as={Link} to="/login" className="nav-link-item" eventKey="3">Login</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Banner - Now properly spaced below navbar */}
      <div className="banner-container">
        <img
          src="/images/banner_2.png"
          className="banner-img"
          alt="Company Banner"
        />
      </div>
    </div>
  );
};

export default Navigation;